export default "__VITE_ASSET__d4ECnVyF__"